import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { TargetValueType } from "../CompareValuePanel";
import { OrgUtil } from "../../../util";

export default (props)=>{
	const { categoryInfo } = props;
	const { name, id } = categoryInfo;
	return (<CounselingGeneric 
		typeKey={name}
		subHeader={name}
		fetchMain={(passProps)=>ReportAction.fetchCounCategory({...passProps, category:id})}
		getAutoSelectItem={(items)=>{
			return items[0].id;
		}}
	/>);
};


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingCategory.js